import script from "./TwModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./TwModal.vue?vue&type=script&lang=ts&setup=true"

import "./TwModal.vue?vue&type=style&index=0&id=87dd4d86&lang=css"

const __exports__ = script;

export default __exports__